import { CalendarEventChipRenderProps } from '../types';
import { CalendarChip } from './CalendarChip';

export const LeadChip = ({ eventInfo }: CalendarEventChipRenderProps) => {
  const { timeText } = eventInfo.event.extendedProps;

  return (
    <CalendarChip
      eventInfo={eventInfo}
      className="bg-zinc-300 dark:bg-zinc-200 dark:text-background dark:font-semibold border-zinc-300 dark:border-zinc-800 text-foreground"
    >
      <span className="font-bold">{timeText}</span>
      <span>{eventInfo.event.title}</span>
    </CalendarChip>
  );
};
